/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from "react-redux";
import DataRow from "./DataRow";
import {
  toFixedVal,
  getStoreChecker,
  getDate,
} from "../../utils/utils";
import { useLazyQuery } from "@apollo/client";
import {
  GET_DEFAULT_LOCATION,
  GET_SERVICES_SUMMARY_DRIVERS_DETAILS_SUMMARY,
} from "../../graphql/queries.js";
import ErrorMessage from "../ErrorMessage";
import {
  DATA_FETCH_ERROR,
  ONLOAN_INVALID_STOREID_ERROR,
} from "../../common/constants";

const ServicesDetailTab = ({ employeeInfo = {}, dateMatrix }) => {
  const [selectedLocation, setSelectedLocation] = React.useState(
    JSON.parse(sessionStorage.getItem("selectedLocation"))
  );
  let selectedStoreId = localStorage.getItem("storeId");
  const activeStorechecker = getStoreChecker(selectedStoreId);
  const [getDefaultLocation, { error: locationError = {} }] = useLazyQuery(
    GET_DEFAULT_LOCATION,
    {
      onCompleted: (data) => {
        let { salesSummaryV2 } = data;
        if (selectedLocation.locationName === "NA") {
          setSelectedLocation({
            locationNo: salesSummaryV2?.location?.primaryLocationNumber,
            locationName: salesSummaryV2?.location?.primaryLocationName,
          });
          sessionStorage.setItem(
            "selectedLocation",
            JSON.stringify({
              locationNo: salesSummaryV2?.location?.primaryLocationNumber,
              locationName: salesSummaryV2?.location?.primaryLocationName,
            })
          );
        }
      },
    }
  );

  const userEmail = employeeInfo.adUpn;

  useEffect(() => {
    if (userEmail && (activeStorechecker === true || selectedStoreId === "")) {
      getDefaultLocation({
        variables: { request: { email: userEmail, storeId: selectedStoreId } },
        context: {
          headers: {
            Authorization: localStorage.getItem("jwtToken"),
          },
        },
      });
    }
  }, [userEmail, getDefaultLocation, selectedStoreId, activeStorechecker]);

  const [
    getServicesSummary,
    {
      data: { services: { services = [] } = {} } = {},
      error: errors = {},
      loading: services_loading,
    },
  ] = useLazyQuery(GET_SERVICES_SUMMARY_DRIVERS_DETAILS_SUMMARY);

  useEffect(() => {
    if (
      userEmail &&
      dateMatrix &&
      selectedLocation &&
      selectedLocation?.locationName !== "NA"
    ) {
      getServicesSummary({
        variables: {
          request: {
            email: userEmail,
            location: {
              primaryLocationNumber: selectedLocation?.locationNo,
              primaryLocationName: selectedLocation?.locationName,
            },
            toDate: getDate("YESTERDAY", ""),
            matrixType: dateMatrix === "YESTERDAY" ? "DAY" : dateMatrix,
          },
        },
        context: {
          headers: {
            Authorization: localStorage.getItem("jwtToken"),
          },
        },
      });
    }
  }, [userEmail, dateMatrix, selectedLocation, getServicesSummary]);

  return (
    <div className="services-detail-tab">
      {services_loading && (
        <div className="services-detail-loader">
          <CircularProgress color="primary" size={30} />
        </div>
      )}
      {!services_loading && (
        <>
          {errors.message || locationError.message ? (
            <ErrorMessage
              statusCode={
                errors?.networkError?.statusCode ||
                locationError?.networkError?.statusCode
              }
              message={DATA_FETCH_ERROR}
            />
          ) : null}
          {activeStorechecker === false && selectedStoreId ? (
            <ErrorMessage message={ONLOAN_INVALID_STOREID_ERROR} />
          ) : null}
          <div className="services-detail-table-container">
            <div className="table-content">
              <div className="flex row">
                <div className="header-text">Balloons</div>
              </div>
              <div className="px-10 py-20">
                <DataRow
                  title="Total Sales $"
                  primaryValue={
                    `$` +
                    Math.round(
                      services?.balloon?.totalSalesAmount ?? 0
                    ).toLocaleString("en")
                  }
                />
                <DataRow
                  title="Total Sales Units"
                  primaryValue={toFixedVal(
                    services?.balloon?.totalSalesUnits ?? 0
                  )}
                />
                <div className="border-row"></div>
                <DataRow
                  title="ADS"
                  primaryValue={toFixedVal(
                    services?.balloon?.ads ?? 0,
                    "$",
                    "start_nospace",
                    2
                  )}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

ServicesDetailTab.propTypes = {
  employeeInfo: PropTypes.shape({
    adUpn: PropTypes.string,
  }),
  dateMatrix: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    employeeInfo: state.auth.employeeInfo,
    dateMatrix: state?.salesSummary?.currentDateMatrix?.value,
  };
};
export default connect(mapStateToProps, undefined)(ServicesDetailTab);
